import * as React from "react";

export default () => {
  return (
    <div>
      Andel av fastighetsskatten som ska debiteras hyresgästen, i procent
    </div>
  );
};
